// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"666ce1a9","358":"bf4b8148","378":"97138367","440":"5afa6720","494":"7eb61b43","541":"4f6eeff1","598":"9be61d50","671":"e551bc88","741":"f4632733","762":"2f08912e","784":"7cd3163d","824":"7895a7e1","825":"5263841d","886":"5a3f9e18","894":"a129f0bf","980":"5198b29d"}[chunkId] + ".chunk.js";
};